<template>
	<div v-if="isLoadingCheck">
		<register-form	v-show="page == 'register_form'"
                    @onClicknext="onClicknext($event)">
    	</register-form>

		<register-term v-show="page == 'register_term'"
					view="register"
					@onClicknext="onClicknext($event)"
					:busModalTerm="busModalTerm">
		</register-term>

		<register-otp v-show="page == 'register_otp'"
					:lbl="lbl"
					:busOtpModal="busOtpModal"
					@initialOtpModal="initialOtpModal($event)"
					@onClicknext="onClicknext($event)">
		</register-otp>

		<modal view="register" :busModal="busModal"></modal>
	</div>
</template>
<script>


import Vue from "vue";

import RegisterForm from './components/RegisterForm.vue';
import RegisterTerm from './components/TermCompenent.vue';
import RegisterOtp from './components/OtpComponents.vue';

import OtpModel from "@/model/OtpModel.js";
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";

import Modal from "@/components/modal/Modal.vue";


import { TrackingService } from "@/helper/TrackingHelper.js";
import Util from "@/helper/Utility.js"

export default {
    name: "Register",
    components: {
        RegisterForm,
        RegisterTerm,
        RegisterOtp,
        Modal,

    },
    data: function () {
        return {
            lbl: Locale.getLbl(),

            isFirstSave: true,
            objUser: {},
            isLogin: false,

            objauthRequestOTPConfig: {},

            page: "register_form",
            busModal: new Vue(),
            busModalTerm: new Vue(),
            busOtpModal: new Vue(),

            tracking: new TrackingService(this),
            isLoadingCheck: false,


        };
    },
    created: async function () {
        if (await this.checkMaintenance()) {
            console.log("checkMaintenance TRUE")
            return
        }
        Account.loginStatus().then((status) => {
            if (!status) {
                window.location.replace('/landing/line');
            }
        });
    },
    mounted: function () {

    },
    methods: {

        onClicknext: function (data) {

            if (data.tag == 'register_term') {
                this.page = 'register_term';

                this.tracking.screenName("regis_consent");
                this.tracking.event("regis_consent", "view_consent");

                this.busModalTerm.$emit('setPhoneNumber',{ data : data});
            } else if (data.tag == 'register_otp') {

                this.tracking.screenName("regis_otp");
                this.tracking.event("regis_otp_error", "view_otp");

                this.page = 'register_otp';
                this.objauthRequestOTPConfig = new OtpModel.AuthRequestOTPConfigModelBuilder().create();
                this.objauthRequestOTPConfig.strContactNumber = data.registerdata.data.contac_number;
                this.objauthRequestOTPConfig.strChannel = "Register";

                var registerdata = {
                    birthdate: data.registerdata.data.birthdate,
                    information: data.registerdata,
                    otpdata: this.objauthRequestOTPConfig
                }
                this.busOtpModal.$emit('showOtpModal',registerdata);
            } else if (data.tag == "register_form") {

                this.page = 'register_form';
            }
        },
        checkMaintenance: function () {
            return new Promise(() => {
                console.log("checkMaintenance")
                let StartDateMaintenance = window.StartDateMaintenance;
                let EndDateMaintenance = window.EndDateMaintenance;

                // StartDateMaintenance = "2024-02-19 15:00:00"
                // EndDateMaintenance = "2024-02-19 15:08:00"
                if (Util.isEmptyStr(StartDateMaintenance) || Util.isEmptyStr(EndDateMaintenance)) {
                    this.isLoadingCheck = true;
                    console.log("checkMaintenance ISEMPTY")
                    return false;
                } else {
                    var stDate = new Date(StartDateMaintenance)
                    var edDate = new Date(EndDateMaintenance)
                    var today = new Date()
                    if ( today > stDate && today < edDate)
                    {
                        window.location.replace('/maintenance');
                        return true;
                    }
                    this.isLoadingCheck = true;
                    return false;
                }
            });
        }

    },
};
</script>
<style lang="scss" scoped>

</style>

